import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.documents');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-documents',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.documents/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.source-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.source-text-expanded {
  max-height: 34rem;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.quality-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  font-size: 0.625rem;
  line-height: 1rem;
  font-weight: 700;
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.2);
}

.heading-path {
  overflow-wrap: anywhere;
  word-break: keep-all;
}

.processing-chunk-full-text {
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.08);
}

.chunk-context-before,
.chunk-context-after {
  min-width: 0;
}

.chunk-context-text {
  max-height: 22rem;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.chunk-detail-list {
  max-height: 38rem;
  overflow-y: auto;
  overscroll-behavior: contain;
}`],
})
export class PageDocumentsComponent implements OnInit {
    public loading: boolean = true;
    public chunkLoading: boolean = false;
    public documentFullTextLoading: boolean = false;
    public errorMessage: string = '';
    public noticeMessage: string = '';
    public documents: any[] = [];
    public sources: any[] = [];
    public selectedSourceId: string = 'nahf-document-archive';
    public chunks: any[] = [];
    public chunkSets: any[] = [];
    public works: any[] = [];
    public processingSelection: any = {};
    public selectedChunkSetId: string = '';
    public selectedDocumentVersionId: string = '';
    public selectedWorkId: string = '';
    public selectedDocument: any = null;
    public selectedChunk: any = null;
    public selectedChunkDetail: any = null;
    public chunkDetailLoading: boolean = false;
    public detailErrorMessage: string = '';
    public expandedTexts: { [key: string]: boolean } = {};
    public expandedChunkPanels: { [key: string]: boolean } = {};
    public chunkTotal: number = 0;
    public chunkOffset: number = 0;
    public chunkLimit: number = 100;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("overview", {
                limit: 100,
                source_id: this.selectedSourceId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "도서 목록을 불러오지 못했습니다."
                );
                return;
            }

            this.sources = this.toArray(response.data?.sources);
            this.documents = this.toArray(response.data?.documents || response.data);
            if (this.documents.length > 0) {
                await this.selectDocument(this.documents[0]);
            } else {
                this.selectedDocument = null;
                this.selectedChunk = null;
                this.selectedChunkDetail = null;
                this.chunks = [];
                this.chunkSets = [];
                this.works = [];
                this.resetProcessingSelection();
                this.chunkTotal = 0;
                this.chunkOffset = 0;
            }
        } catch (_error) {
            this.errorMessage = "도서 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async selectSource(source: any) {
        if (this.documentFullTextLoading) return;
        const sourceId = String(source?.id || '').trim();
        if (!sourceId || sourceId === this.selectedSourceId) return;
        this.selectedSourceId = sourceId;
        this.expandedTexts = {};
        this.noticeMessage = '';
        await this.load();
    }

    public isSourceSelected(source: any): boolean {
        return String(source?.id || '') === this.selectedSourceId;
    }

    public sourceName(source: any): string {
        return source?.name || source?.id || '데이터 소스';
    }

    public get isArchiveSource(): boolean {
        return this.selectedSourceId === 'nahf-document-archive';
    }

    public async selectDocument(document: any) {
        if (!document || this.chunkLoading || this.documentFullTextLoading) return;

        const documentChanged = this.documentId(document) !== this.documentId(this.selectedDocument);
        this.selectedDocument = document;
        this.noticeMessage = '';
        if (documentChanged) {
            this.chunkSets = [];
            this.works = [];
            this.resetProcessingSelection();
        }
        await this.loadChunkPage(0, document);
    }

    public async previousChunkPage() {
        if (!this.hasPreviousChunkPage || this.chunkLoading) return;
        await this.loadChunkPage(Math.max(0, this.chunkOffset - this.chunkLimit));
    }

    public async nextChunkPage() {
        if (!this.hasNextChunkPage || this.chunkLoading) return;
        await this.loadChunkPage(this.chunkOffset + this.chunkLimit);
    }

    public get hasPreviousChunkPage(): boolean {
        return this.chunkOffset > 0;
    }

    public get hasNextChunkPage(): boolean {
        return this.chunkOffset + this.chunks.length < this.chunkTotal;
    }

    public get chunkRangeStart(): number {
        return this.chunkTotal > 0 ? this.chunkOffset + 1 : 0;
    }

    public get chunkRangeEnd(): number {
        return Math.min(this.chunkOffset + this.chunks.length, this.chunkTotal);
    }

    public get currentChunkPage(): number {
        return this.chunkTotal > 0 ? Math.floor(this.chunkOffset / this.chunkLimit) + 1 : 0;
    }

    public get totalChunkPages(): number {
        return this.chunkTotal > 0 ? Math.ceil(this.chunkTotal / this.chunkLimit) : 0;
    }

    public async selectChunkSet(event: any) {
        if (this.chunkLoading || this.documentFullTextLoading) return;
        const chunkSetId = this.eventValue(event);
        if (!chunkSetId || chunkSetId === this.selectedChunkSetId) return;

        const selected = this.chunkSets.find(
            (item) => this.chunkSetId(item) === chunkSetId
        );
        this.selectedChunkSetId = chunkSetId;
        this.selectedDocumentVersionId = String(
            selected?.document_version_id || selected?.source_document_version_id || ''
        );
        this.selectedWorkId = '';
        await this.loadChunkPage(0);
    }

    public async selectWork(event: any) {
        if (this.chunkLoading || this.documentFullTextLoading) return;
        const workId = this.eventValue(event);
        if (!workId || workId === this.selectedWorkId) return;

        this.selectedWorkId = workId;
        await this.loadChunkPage(0);
    }

    public chunkSetId(chunkSet: any): string {
        return String(chunkSet?.id || chunkSet?.chunk_set_id || '');
    }

    public chunkSetLabel(chunkSet: any): string {
        const version = chunkSet?.chunker_version || chunkSet?.version || '버전 미상';
        const strategy = chunkSet?.chunking_strategy || chunkSet?.strategy || '청킹 전략 미상';
        return String(version) + ' · ' + String(strategy);
    }

    public workId(work: any): string {
        return String(work?.id || work?.work_id || '');
    }

    public workLabel(work: any): string {
        return String(work?.title || work?.name || work?.heading || this.workId(work) || '작품 미상');
    }

    public scopeValue(value: any, emptyLabel: string = '미지정'): string {
        return value === undefined || value === null || value === ''
            ? emptyLabel
            : String(value);
    }

    public idListLabel(values: string[]): string {
        return values.length > 0 ? values.join(', ') : '없음';
    }

    private async loadChunkPage(
        offset: number,
        document: any = this.selectedDocument,
        preferredChunkId: string = ''
    ) {
        if (!document) return;

        this.selectedChunk = null;
        this.selectedChunkDetail = null;
        this.chunks = [];
        this.expandedTexts = {};
        this.expandedChunkPanels = {};
        this.detailErrorMessage = '';
        this.chunkLoading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("document_chunks", {
                document_id: this.documentId(document),
                limit: this.chunkLimit,
                offset: Math.max(0, offset),
                chunk_set_id: this.selectedChunkSetId,
                document_version_id: this.selectedDocumentVersionId,
                work_id: this.selectedWorkId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "문서 조각을 불러오지 못했습니다."
                );
                return;
            }

            const payload = response.data || {};
            this.selectedDocument = payload.document || document;
            this.chunks = this.toArray(payload.chunks || payload);
            this.chunkSets = this.toArray(payload.chunk_sets);
            this.works = this.toArray(payload.works);
            this.applyProcessingSelection(payload.selection || {});
            this.chunkTotal = this.toNonNegativeNumber(payload.total, this.chunks.length);
            this.chunkOffset = this.toNonNegativeNumber(payload.offset, Math.max(0, offset));
            this.chunkLimit = Math.max(
                1,
                Math.min(100, this.toNonNegativeNumber(payload.limit, this.chunkLimit) || 100)
            );
            this.selectedChunk = this.chunks.find(
                (item) => this.chunkId(item) === String(preferredChunkId || '')
            ) || this.chunks[0] || null;
            if (this.selectedChunk) await this.loadChunkDetail(this.selectedChunk, false);
        } catch (_error) {
            this.errorMessage = "문서 조각을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.chunkLoading = false;
            await this.service.render();
        }
    }

    public async selectChunk(chunk: any) {
        if (!chunk || this.chunkDetailLoading) return;
        this.selectedChunk = chunk;
        this.selectedChunkDetail = null;
        this.detailErrorMessage = '';
        await this.loadChunkDetail(chunk, true);
    }

    public get canLoadSelectedDocumentFullText(): boolean {
        if (!this.selectedDocument || !this.isArchiveSource) return false;
        const available = this.selectedDocument?.full_text_available
            ?? this.selectedDocument?.metadata?.full_text_available;
        const ingested = this.selectedDocument?.full_text_ingested
            ?? this.selectedDocument?.metadata?.full_text_ingested;
        return available === true && ingested !== true;
    }

    public get selectedDocumentHasFullText(): boolean {
        const ingested = this.selectedDocument?.full_text_ingested
            ?? this.selectedDocument?.metadata?.full_text_ingested;
        const stored = this.selectedDocument?.full_text_stored
            ?? this.selectedDocument?.metadata?.full_text_stored;
        return ingested === true || stored === true;
    }

    public get selectedDocumentStorageLabel(): string {
        const stored = this.selectedDocument?.full_text_stored
            ?? this.selectedDocument?.metadata?.full_text_stored;
        if (stored !== true) return "";

        const count = this.selectedDocument?.full_text_char_count
            ?? this.selectedDocument?.metadata?.full_text_char_count
            ?? this.selectedDocument?.full_text_length
            ?? this.selectedDocument?.metadata?.full_text_length
            ?? 0;
        return "MySQL 전체 원문 저장됨 · "
            + Number(count || 0).toLocaleString("ko-KR") + "자";
    }

    public async loadSelectedDocumentFullText() {
        if (!this.canLoadSelectedDocumentFullText || this.documentFullTextLoading) return;

        this.documentFullTextLoading = true;
        this.errorMessage = '';
        this.noticeMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("load_full_text", {
                document_id: this.documentId(this.selectedDocument)
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "전체 원문을 불러오지 못했습니다."
                );
                return;
            }

            const payload = response.data || {};
            const previousDocumentId = this.documentId(this.selectedDocument);
            this.selectedDocument = payload.document || this.selectedDocument;
            this.resetProcessingSelection();
            const processing = payload.processing || {};
            const chunkSet = payload.chunk_set || {};
            const version = payload.version || {};
            this.applyProcessingSelection(
                processing.selection
                || payload.selection
                || {
                    chunk_set_id: chunkSet.id || payload.chunk_set_id,
                    document_version_id: version.id
                        || chunkSet.document_version_id
                        || payload.document_version_id,
                    work_id: payload.work_id
                }
            );
            const successMessage = payload.message
                || "전체 원문 구조와 버전형 처리 조각을 MySQL에 저장했습니다.";

            const documentIndex = this.documents.findIndex(
                (item) => this.documentId(item) === previousDocumentId
            );
            if (documentIndex >= 0) this.documents[documentIndex] = this.selectedDocument;

            await this.loadChunkPage(0, this.selectedDocument);
            if (!this.errorMessage) this.noticeMessage = successMessage;
        } catch (_error) {
            this.errorMessage = "전체 원문을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.documentFullTextLoading = false;
            await this.service.render();
        }
    }

    private async loadChunkDetail(chunk: any, render: boolean = true): Promise<boolean> {
        const chunkId = this.chunkId(chunk);
        if (!chunkId || !this.selectedDocument) return false;

        this.chunkDetailLoading = true;
        this.detailErrorMessage = '';
        if (render) await this.service.render();

        try {
            const response = await wiz.call("chunk_detail", {
                document_id: this.documentId(this.selectedDocument),
                chunk_id: chunkId
            });
            if (response.code !== 200) {
                this.detailErrorMessage = this.responseMessage(
                    response.data,
                    "문서 조각 상세를 불러오지 못했습니다."
                );
                return false;
            }

            const detail = response.data || {};
            if (!detail.chunk) {
                this.detailErrorMessage = "문서 조각 상세에 현재 조각 정보가 없습니다.";
                return false;
            }

            this.selectedChunkDetail = detail;
            this.selectedChunk = detail.chunk;
            const index = this.chunks.findIndex(
                (item) => this.chunkId(item) === this.chunkId(detail.chunk)
            );
            if (index >= 0) this.chunks[index] = detail.chunk;
            return true;
        } catch (_error) {
            this.detailErrorMessage = "문서 조각 상세를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
            return false;
        } finally {
            this.chunkDetailLoading = false;
            if (render) await this.service.render();
        }
    }

    public get previousChunk(): any {
        if (
            this.selectedChunkDetail?.chunk
            && this.chunkId(this.selectedChunkDetail.chunk) === this.chunkId(this.selectedChunk)
        ) {
            return this.selectedChunkDetail.previous_chunk || null;
        }
        return this.neighborChunk(this.selectedChunk?.previous_chunk_id, -1);
    }

    public get nextChunk(): any {
        if (
            this.selectedChunkDetail?.chunk
            && this.chunkId(this.selectedChunkDetail.chunk) === this.chunkId(this.selectedChunk)
        ) {
            return this.selectedChunkDetail.next_chunk || null;
        }
        return this.neighborChunk(this.selectedChunk?.next_chunk_id, 1);
    }

    public async viewPreviousChunk() {
        await this.viewLinkedChunk('previous');
    }

    public async viewNextChunk() {
        await this.viewLinkedChunk('next');
    }

    private async viewLinkedChunk(direction: 'previous' | 'next') {
        if (this.chunkLoading || this.chunkDetailLoading || !this.selectedChunk) return;

        const neighbor = direction === 'previous' ? this.previousChunk : this.nextChunk;
        const referenceId = direction === 'previous'
            ? this.selectedChunk?.previous_chunk_id
            : this.selectedChunk?.next_chunk_id;
        const targetId = this.chunkId(neighbor) || String(referenceId || '');
        if (!targetId) return;

        const targetIndex = Number(neighbor?.chunk_index);
        if (
            Number.isFinite(targetIndex)
            && targetIndex >= 0
            && (
                targetIndex < this.chunkOffset
                || targetIndex >= this.chunkOffset + this.chunks.length
            )
        ) {
            const targetOffset = Math.floor(targetIndex / this.chunkLimit) * this.chunkLimit;
            await this.loadChunkPage(targetOffset, this.selectedDocument, targetId);
            return;
        }

        const listed = this.chunks.find((item) => this.chunkId(item) === targetId);
        await this.selectChunk(listed || neighbor || { id: targetId });
    }

    public isDocumentSelected(document: any): boolean {
        return this.documentId(document) === this.documentId(this.selectedDocument);
    }

    public isChunkSelected(chunk: any): boolean {
        return this.chunkId(chunk) === this.chunkId(this.selectedChunk);
    }

    public documentId(document: any): string {
        return String(document?.id || document?.document_id || document?.external_id || "");
    }

    public documentTitle(document: any): string {
        return document?.title || document?.document_title || "제목 없음";
    }

    public documentAuthor(document: any): string {
        return document?.author || document?.metadata?.author || "저자 미상";
    }

    public documentYear(document: any): string {
        const value = document?.publication_year ?? document?.year;
        return value === undefined || value === null || value === "" ? "연도 미상" : String(value);
    }

    public documentLanguage(document: any): string {
        return document?.language || document?.metadata?.language || "언어 미상";
    }

    public documentVersion(document: any): string {
        const value = document?.metadata?.source_version;
        return value === undefined || value === null ? '-' : 'v' + String(value);
    }

    public documentChunkCount(document: any): number {
        const value = document?.chunk_count ?? document?.chunks_count ?? document?.total_chunks;
        const count = Number(value || 0);
        return Number.isFinite(count) ? count : 0;
    }

    public selectedDocumentChunkSummary(): string {
        if (this.chunkTotal <= 0) return "0개 문서 조각";
        return this.chunkRangeStart.toLocaleString("ko-KR")
            + "–" + this.chunkRangeEnd.toLocaleString("ko-KR")
            + " 표시 / 전체 " + this.chunkTotal.toLocaleString("ko-KR")
            + "개 문서 조각";
    }

    public formatNumber(value: number): string {
        return Number(value || 0).toLocaleString("ko-KR");
    }

    public chunkId(chunk: any): string {
        return String(chunk?.id || chunk?.chunk_id || chunk?.external_id || "");
    }

    public chunkPage(chunk: any): string {
        const start = chunk?.page_start
            ?? chunk?.page
            ?? chunk?.page_number
            ?? chunk?.metadata?.page_start
            ?? chunk?.metadata?.page;
        const end = chunk?.page_end ?? chunk?.metadata?.page_end ?? start;
        if (
            (start === undefined || start === null || start === "")
            && (end === undefined || end === null || end === "")
        ) return "원본 정보 없음";
        if (start === undefined || start === null || start === "") return String(end);
        if (end === undefined || end === null || end === "" || String(start) === String(end)) {
            return String(start);
        }
        return String(start) + "–" + String(end);
    }

    public chunkHeadingPath(chunk: any): string {
        const value = chunk?.heading_path
            ?? chunk?.metadata?.heading_path
            ?? chunk?.metadata?.structure?.heading_path
            ?? chunk?.metadata?.structure?.hierarchy;
        return this.headingPathValue(value);
    }

    public chunkIndex(chunk: any): string {
        const value = chunk?.chunk_index ?? chunk?.index ?? chunk?.order;
        return value === undefined || value === null || value === "" ? "-" : String(value);
    }

    public chunkText(chunk: any): string {
        return this.chunkFullText(chunk);
    }

    public chunkFullText(chunk: any): string {
        if (typeof chunk === 'string') return chunk;
        return String(
            chunk?.full_text
            || chunk?.text
            || chunk?.content
            || chunk?.original_text
            || "원문 없음"
        );
    }

    public chunkPreview(chunk: any): string {
        const provided = chunk?.text_preview;
        if (provided !== undefined && provided !== null && String(provided).trim()) {
            return String(provided);
        }
        return this.createPreview(this.chunkFullText(chunk));
    }

    public displayedChunkText(chunk: any, index: number, context: string): string {
        return this.isTextExpanded(chunk, index, context)
            ? this.chunkFullText(chunk)
            : this.chunkPreview(chunk);
    }

    public async toggleChunkText(chunk: any, index: number, context: string) {
        const key = this.chunkTextKey(chunk, index, context);
        this.expandedTexts[key] = !this.expandedTexts[key];
        await this.service.render();
    }

    public isTextExpanded(chunk: any, index: number, context: string): boolean {
        return this.expandedTexts[this.chunkTextKey(chunk, index, context)] === true;
    }

    public chunkToggleLabel(chunk: any, index: number, context: string): string {
        if (this.isTextExpanded(chunk, index, context)) return "접기";
        return this.isSearchExcerpt(chunk) ? "발췌문 펼치기" : "전체 보기";
    }

    public isSearchExcerpt(chunk: any): boolean {
        const type = String(
            chunk?.content_type
            || chunk?.metadata?.content_type
            || ""
        ).toLowerCase();
        const scope = String(chunk?.metadata?.ingestion_scope || "").toLowerCase();
        const kind = String(chunk?.metadata?.record_kind || "").toLowerCase();
        return type === "search_excerpt"
            || scope === "validation_excerpt"
            || kind === "source_chunk_excerpt";
    }

    public isCompleteText(chunk: any): boolean {
        const explicit = chunk?.is_complete_text ?? chunk?.metadata?.is_complete_text;
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return !this.isSearchExcerpt(chunk) && !this.isSourceTruncated(chunk);
    }

    public isSourceTruncated(chunk: any): boolean {
        const explicit = chunk?.is_source_truncated ?? chunk?.metadata?.is_source_truncated;
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return this.isSearchExcerpt(chunk) || chunk?.metadata?.excerpt_truncated === true;
    }

    public chunkLimitationReason(chunk: any): string {
        if (!this.isSearchExcerpt(chunk)) return "";
        return chunk?.limitation_reason
            || chunk?.metadata?.limitation_reason
            || "외부 API가 전체 원문이 아닌 제한된 검색 발췌문만 제공함";
    }

    public chunkForcedSplit(chunk: any): boolean {
        return (chunk?.forced_split ?? chunk?.metadata?.forced_split) === true;
    }

    public chunkContentLabel(chunk: any): string {
        if (chunk?.is_neighbor_preview === true) return "연결 조각";
        if (this.isSearchExcerpt(chunk)) return "검색 발췌문";
        if (this.isCompleteText(chunk)) return "전체 원문 기반 조각";
        return "불완전 원문";
    }

    public chunkBoundaryLabel(chunk: any): string {
        if (chunk?.is_neighbor_preview === true) return "경계 정보 미제공";
        if (this.chunkForcedSplit(chunk)) return "강제 분할됨";
        if (this.isSearchExcerpt(chunk)) return "구조·문장 경계 미검증";

        const reason = this.chunkSplitReason(chunk);
        if (reason === "oversized_single_sentence_preserved") return "긴 단일 문장 보존";
        if (reason === "sentence_boundary") return "긴 블록을 문장 경계에서 분할";
        if (reason === "source_block_boundary") return "SourceBlock 경계 유지";
        if (reason === "source_block_atomic") return "SourceBlock 원형 유지";
        return "구조·문장 경계 보존";
    }

    public chunkContentClass(chunk: any): string {
        if (this.isSearchExcerpt(chunk)) return "bg-amber-50 text-amber-800 ring-amber-600/20";
        if (this.isCompleteText(chunk)) return "bg-emerald-50 text-emerald-700 ring-emerald-600/20";
        return "bg-slate-100 text-slate-700 ring-slate-500/20";
    }

    public chunkBoundaryClass(chunk: any): string {
        return this.chunkForcedSplit(chunk)
            ? "bg-red-50 text-red-700 ring-red-600/20"
            : "bg-sky-50 text-sky-700 ring-sky-600/20";
    }

    public chunkExtractionUsable(chunk: any): boolean {
        const explicit = chunk?.knowledge_extraction_usable
            ?? chunk?.knowledge_extraction_eligible
            ?? chunk?.extraction_eligible
            ?? chunk?.metadata?.knowledge_extraction_usable
            ?? chunk?.metadata?.knowledge_extraction_eligible
            ?? chunk?.metadata?.extraction_eligible;
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return this.isCompleteText(chunk) && !this.isSearchExcerpt(chunk);
    }

    public chunkCharacterRange(chunk: any): string {
        const start = chunk?.character_start ?? chunk?.metadata?.character_start;
        const end = chunk?.character_end ?? chunk?.metadata?.character_end;
        if (start === undefined || start === null || end === undefined || end === null) return "위치 미상";
        const basis = chunk?.offset_basis ?? chunk?.metadata?.offset_basis;
        return String(start) + "–" + String(end)
            + (basis ? " · " + String(basis) : "");
    }

    public chunkSentenceCount(chunk: any): string {
        const value = chunk?.sentence_count ?? chunk?.metadata?.sentence_count;
        return value === undefined || value === null ? "-" : String(value);
    }

    public chunkStrategy(chunk: any): string {
        const strategy = chunk?.chunking_strategy
            || chunk?.metadata?.chunking_strategy
            || (this.isSearchExcerpt(chunk) ? "외부 검색 결과" : "SourceBlock 구조·문장 경계 기반");
        const version = chunk?.chunker_version || chunk?.metadata?.chunker_version;
        return version ? String(strategy) + " · " + String(version) : String(strategy);
    }

    public chunkOverlapCount(chunk: any): string {
        const value = chunk?.overlap_sentence_count ?? chunk?.metadata?.overlap_sentence_count;
        return value === undefined || value === null ? "-" : String(value);
    }

    public chunkContextSentenceCount(chunk: any, direction: 'before' | 'after'): string {
        return String(this.contextSentenceIds(direction, chunk).length);
    }

    public chunkScope(chunk: any, key: string): string {
        const value = chunk?.[key]
            ?? chunk?.metadata?.[key]
            ?? this.processingSelection?.[key];
        return this.scopeValue(value);
    }

    public chunkNormalizationVersion(chunk: any): string {
        return this.scopeValue(
            chunk?.normalization_version ?? chunk?.metadata?.normalization_version
        );
    }

    public chunkSplitReason(chunk: any): string {
        return String(chunk?.split_reason || chunk?.metadata?.split_reason || '');
    }

    public contextText(direction: 'before' | 'after', chunk: any = this.selectedChunk): string {
        const key = direction === 'before' ? 'context_before_text' : 'context_after_text';
        const value = chunk?.[key] ?? chunk?.metadata?.[key];
        return value === undefined || value === null ? '' : String(value);
    }

    public contextSentenceIds(
        direction: 'before' | 'after',
        chunk: any = this.selectedChunk
    ): string[] {
        const key = direction === 'before'
            ? 'context_before_sentence_ids'
            : 'context_after_sentence_ids';
        const direct = this.toIdArray(chunk?.[key] ?? chunk?.metadata?.[key]);
        if (direct.length > 0 || this.chunkId(chunk) !== this.chunkId(this.selectedChunk)) {
            return direct;
        }
        const rows = direction === 'before'
            ? this.toArray(this.selectedChunkDetail?.context_before_sentences)
            : this.toArray(this.selectedChunkDetail?.context_after_sentences);
        return rows.map((item) => this.sentenceId(item)).filter((item) => Boolean(item));
    }

    public sourceBlockIds(chunk: any = this.selectedChunk): string[] {
        return this.toIdArray(
            chunk?.source_block_ids ?? chunk?.metadata?.source_block_ids
        );
    }

    public primarySentenceIds(chunk: any = this.selectedChunk): string[] {
        return this.toIdArray(
            chunk?.primary_sentence_ids ?? chunk?.metadata?.primary_sentence_ids
        );
    }

    public get selectedSourceBlocks(): any[] {
        return this.toArray(this.selectedChunkDetail?.source_blocks);
    }

    public get selectedPrimarySentences(): any[] {
        return this.toArray(this.selectedChunkDetail?.primary_sentences);
    }

    public hasContext(direction: 'before' | 'after'): boolean {
        return Boolean(this.contextText(direction).trim())
            || this.contextSentenceIds(direction).length > 0;
    }

    public hasSourceBlocks(): boolean {
        return this.selectedSourceBlocks.length > 0 || this.sourceBlockIds().length > 0;
    }

    public hasPrimarySentences(): boolean {
        return this.selectedPrimarySentences.length > 0 || this.primarySentenceIds().length > 0;
    }

    public async toggleChunkPanel(panel: string) {
        const key = this.chunkPanelKey(panel);
        this.expandedChunkPanels[key] = !this.expandedChunkPanels[key];
        await this.service.render();
    }

    public isChunkPanelExpanded(panel: string): boolean {
        return this.expandedChunkPanels[this.chunkPanelKey(panel)] === true;
    }

    public chunkPanelLabel(panel: string, openLabel: string, closeLabel: string): string {
        return this.isChunkPanelExpanded(panel) ? closeLabel : openLabel;
    }

    public sourceBlockId(block: any): string {
        return String(block?.id || block?.source_block_id || '');
    }

    public sourceBlockIndex(block: any): string {
        const value = block?.block_index ?? block?.source_order ?? block?.index;
        return value === undefined || value === null ? '-' : String(value);
    }

    public sourceBlockType(block: any): string {
        return String(block?.block_type || block?.content_type || block?.type || '원문 블록');
    }

    public sourceBlockText(block: any): string {
        return String(
            block?.full_text
            || block?.normalized_text
            || block?.text
            || block?.content
            || '원문 없음'
        );
    }

    public sourceBlockHeadingPath(block: any): string {
        return this.headingPathValue(block?.heading_path ?? block?.metadata?.heading_path);
    }

    public sourceBlockPage(block: any): string {
        return this.chunkPage(block);
    }

    public sentenceId(sentence: any): string {
        return String(sentence?.id || sentence?.sentence_id || '');
    }

    public sentenceIndex(sentence: any): string {
        const value = sentence?.sentence_index ?? sentence?.index ?? sentence?.source_order;
        return value === undefined || value === null ? '-' : String(value);
    }

    public sentenceText(sentence: any): string {
        return String(sentence?.full_text || sentence?.text || sentence?.content || '문장 원문 없음');
    }

    public sentenceSourceBlockId(sentence: any): string {
        return String(sentence?.source_block_id || '');
    }

    public sentenceCharacterRange(sentence: any): string {
        const start = sentence?.character_start;
        const end = sentence?.character_end;
        if (start === undefined || start === null || end === undefined || end === null) return '위치 미상';
        return String(start) + '–' + String(end);
    }

    public neighborLabel(chunk: any, emptyLabel: string): string {
        if (!chunk) return emptyLabel;
        return "페이지 " + this.chunkPage(chunk) + " · 순서 " + this.chunkIndex(chunk);
    }

    private neighborChunk(referenceId: any, _offset: number): any {
        if (!this.selectedChunk || !referenceId) return null;

        const direct = this.chunks.find(
            (item) => this.chunkId(item) === String(referenceId)
        );
        if (direct) return direct;

        // 페이지 경계 밖의 실제 이웃은 저장된 연결 ID와 JOIN 미리보기로만 복원한다.
        // 검색 결과 배열 순서를 이웃으로 추정하지 않는다.
        const prefix = _offset < 0 ? "previous" : "next";
        const fullText = this.selectedChunk?.[prefix + "_chunk_full_text"]
            || this.selectedChunk?.[prefix + "_chunk_text"];
        if (!fullText) return null;

        return {
            id: String(referenceId),
            full_text: String(fullText),
            text_preview: this.selectedChunk?.[prefix + "_chunk_text_preview"],
            page: this.selectedChunk?.[prefix + "_chunk_page"],
            chunk_index: this.selectedChunk?.[prefix + "_chunk_index"],
            content_type: "linked_chunk_preview",
            is_neighbor_preview: true,
            is_complete_text: false,
            is_source_truncated: false,
            knowledge_extraction_eligible: false,
        };
    }

    private chunkTextKey(chunk: any, index: number, context: string): string {
        const id = chunk?.id || chunk?.chunk_id || chunk?.external_id || index;
        return this.documentId(this.selectedDocument) + ":" + context + ":" + String(id);
    }

    private chunkPanelKey(panel: string): string {
        return this.documentId(this.selectedDocument)
            + ':' + this.chunkId(this.selectedChunk)
            + ':' + panel;
    }

    private resetProcessingSelection() {
        this.processingSelection = {};
        this.selectedChunkSetId = '';
        this.selectedDocumentVersionId = '';
        this.selectedWorkId = '';
    }

    private applyProcessingSelection(value: any) {
        const selection = value && typeof value === 'object' ? value : {};
        this.processingSelection = selection;
        this.selectedChunkSetId = String(selection.chunk_set_id || '');
        this.selectedDocumentVersionId = String(selection.document_version_id || '');
        this.selectedWorkId = String(selection.work_id || '');
    }

    private eventValue(event: any): string {
        return String(event?.target?.value || '').trim();
    }

    private headingPathValue(value: any): string {
        if (Array.isArray(value)) {
            return value
                .map((item) => {
                    if (item === undefined || item === null) return '';
                    if (typeof item !== 'object') return String(item).trim();
                    return String(
                        item.title
                        || item.name
                        || item.heading
                        || item.label
                        || item.text
                        || item.value
                        || ''
                    ).trim();
                })
                .filter((item) => Boolean(item))
                .join(' › ');
        }
        if (value && typeof value === 'object') {
            return this.headingPathValue(value.path || value.items || value.heading || value.title);
        }
        return value === undefined || value === null ? '' : String(value).trim();
    }

    private toIdArray(value: any): string[] {
        if (Array.isArray(value)) {
            return value
                .map((item) => String(item === undefined || item === null ? '' : item).trim())
                .filter((item) => Boolean(item));
        }
        if (typeof value === 'string' && value.trim()) {
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return this.toIdArray(parsed);
            } catch (_error) { }
            return [value.trim()];
        }
        return [];
    }

    private createPreview(value: string, maximum: number = 260): string {
        const text = String(value || "");
        if (text.length <= maximum) return text;

        const candidate = text.slice(0, maximum);
        const boundaries = [
            candidate.lastIndexOf("\n"),
            candidate.lastIndexOf("다. "),
            candidate.lastIndexOf(". "),
            candidate.lastIndexOf("。"),
            candidate.lastIndexOf("! "),
            candidate.lastIndexOf("? ")
        ];
        const boundary = Math.max(...boundaries);
        const end = boundary >= Math.floor(maximum * 0.55) ? boundary + 1 : maximum;
        return candidate.slice(0, end).trimEnd() + "…";
    }

    private toNonNegativeNumber(value: any, fallback: number = 0): number {
        const parsed = Number(value);
        if (!Number.isFinite(parsed) || parsed < 0) return Math.max(0, fallback);
        return Math.floor(parsed);
    }

    private toArray(value: any): any[] {
        if (Array.isArray(value)) return value;
        if (Array.isArray(value?.items)) return value.items;
        if (Array.isArray(value?.rows)) return value.rows;
        return [];
    }

    private responseMessage(data: any, fallback: string): string {
        return typeof data === 'string' ? data : data?.message || fallback;
    }
}

export default PageDocumentsComponent;